import { Navigate } from 'react-router-dom';
import { ACCOUNT_STATUSES_BLOCKING_ORDERS } from '@lombok/shared';
import { useSessionProfile } from '@/auth/useSessionProfile';
import { useDistributor } from '@/data/hooks';
import { OrderCreatePage } from './OrderCreatePage';

const ORDERS_PATH = '/app/distributor/pedidos';

/**
 * Crear pedido in the distributor portal: for one of its sub-accounts. A suspended, rejected or closed distributor
 * cannot order, so it is sent back to its orders (the banner there says why) instead of getting the form.
 */
export function DistributorOrderCreatePage() {
  const { profile } = useSessionProfile();
  const account = useDistributor(profile?.distributorId);

  if (account.isLoading) return <p className="text-sm text-text-muted">Cargando…</p>;
  if (account.data && ACCOUNT_STATUSES_BLOCKING_ORDERS.includes(account.data.status)) {
    return <Navigate to={ORDERS_PATH} replace />;
  }
  return <OrderCreatePage basePath={ORDERS_PATH} ordersPath={ORDERS_PATH} lockedRate />;
}
